export default {"src":"/_next/static/media/fm.78c0c253.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};